import { useSyncExternalStore } from 'react';
import {
  DESKTOP_QUERY,
  PHONE_LANDSCAPE_QUERY,
  TABLET_QUERY,
  type ScreenLayout,
} from './screenFit';

// The same split as screenLayout(), from media queries so it follows the
// window live: phone < 600, tablet 600-1023, desktop >= 1024, and a
// sideways phone stays a phone.
const QUERIES = [PHONE_LANDSCAPE_QUERY, DESKTOP_QUERY, TABLET_QUERY];

const matches = (query: string) =>
  window.matchMedia?.(query)?.matches ?? false;

/** The layout right now, for code outside React. */
export function currentScreenLayout(): ScreenLayout {
  if (matches(PHONE_LANDSCAPE_QUERY)) return 'phone';
  if (matches(DESKTOP_QUERY)) return 'desktop';
  if (matches(TABLET_QUERY)) return 'tablet';
  return 'phone';
}

function subscribe(onChange: () => void) {
  const lists = QUERIES.map((q) => window.matchMedia?.(q)).filter(Boolean);
  lists.forEach((list) => list?.addEventListener?.('change', onChange));
  return () =>
    lists.forEach((list) => list?.removeEventListener?.('change', onChange));
}

export function useScreenLayout(): ScreenLayout {
  return useSyncExternalStore(subscribe, currentScreenLayout, () => 'phone');
}
